import { useEffect, useState } from "react";
import WithDrawIcon from "../../Assets/images/tools/withdraw.png";

import TxnCbIcon from "../../Assets/images/tools/txnCallback.png";

import SubmittedVendorIcon from "../../Assets/images/tools/vendor (2).png";
import PayoutTxnCB from "../../Assets/images/tools/payout_txn_cb.png";
import WalletBalanceIcon from "../../Assets/images/tools/wallet.png";
import styles from "./tool.module.css";
import SlideBox from "../../Common/SlideBox/SlideBox";
import WithdrawInPayout from "./WithdrawInPayout";
import RegisterVendor from "./RegisterVendor";
import TransactionCallback from "./TransactionCallback";
import SubmittedVendor from "./SubmittedVendor";

import AddWalletBalance from "./AddWalletBalance";
import PayoutRequest from "./PayoutRequest";
import CheckExportConst from "../../Utils/PrivilagesUtilityFun/CheckExportConst";
import ArchieveReport from "./ArchieveReport";
import ArchievedReportsIcon from "../../Assets/images/tools/archieved_report.png";
import Billing from "../../Assets/images/icons/Billing.png";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useApiServices from "../../Utils/useApiService";
import BillingDetails from "./BillingDetails";

const Tools = () => {
  const toolType = {
    withDraw: "withDraw",
    TxnStatus: true,
    rvendor: "rvendor",
    transactionCallback: "transactionCallback",
    transactionStatus: "transactionStatus",
    payoutTransactioncallback: "payoutTransactioncallback",
    addWalletBalance: "addWalletBalance",
    submittedVendor: "submittedVendor",
    PayoutRequest: "PayoutRequest",
    ArchievedReport: "ArchievedReport",
    billingDetails: "billingDetails",
  };

  const { slidebar } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [flag, setFlag] = useState(false);
  const { apiCallFnforGet } = useApiServices();
  const [tool, setTool] = useState("");
  const { mid } = useSelector((state) => state.userData);
  const [previewUrl, setPreviewUrl] = useState(null);

  const toggleRightBar = (type) => {
    if (type) {
      setTool(type);
    }
    setFlag(!flag);
  };

  useEffect(() => {
    if (slidebar == 6) {
      toggleRightBar("ArchievedReport");
      setTimeout(() => {
        window.openArchieveDialough();
      }, 600);
    } else if (slidebar == 5) {
      toggleRightBar("addWalletBalance");
    } else if (slidebar == 1) {
      toggleRightBar("withDraw");
    } else if (slidebar == 2) {
      toggleRightBar("PayoutRequest");
    }
  }, []);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const {
    AddWalletBalancePrivilages,
    hasPrivilagesRegisterVendor,
    WithdrawPrivilages,
    hasPrivilagesSubmittedVendor,
    hasPrivilagesPayoutTxnCallback,
    hasPrivilagesTxnCallback,

    PayoutReqPrivilages,
  } = CheckExportConst();

  return (
    <div className={`content-body ${styles["minHeight"]}`}>
      <div className="container-fluid">
        <div class="card card-inverse card-primary text-center">
          <div class="card-body pb-1">
            <SlideBox flag={flag} toggleRightBar={toggleRightBar}>
              {toolType[tool] === "withDraw" && (
                <WithdrawInPayout tool={tool} />
              )}
              {toolType[tool] === "rvendor" && <RegisterVendor />}
              {toolType[tool] === "transactionCallback" && (
                <TransactionCallback />
              )}
              {toolType[tool] === "addWalletBalance" && <AddWalletBalance />}
              {toolType[tool] === "submittedVendor" && <SubmittedVendor />}
              {toolType[tool] === "PayoutRequest" && <PayoutRequest />}
              {toolType[tool] === "ArchievedReport" && <ArchieveReport />}
              {toolType[tool] === "billingDetails" && <BillingDetails />}

            </SlideBox>
            <div class="row text-center text-lg-start">
              {WithdrawPrivilages ? (
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar("withDraw")}
                  >
                    <img
                      class="img-fluid img-thumbnail"
                      src={WithDrawIcon}
                      alt=""
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Withdraw Amount
                    </h5>
                  </div>
                </div>
              ) : null}
              {PayoutReqPrivilages ? (
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar("PayoutRequest")}
                  >
                    <img
                      class="img-fluid img-thumbnail"
                      src={PayoutTxnCB}
                      alt=""
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Payout Request
                    </h5>
                  </div>
                </div>
              ) : null}

              {hasPrivilagesPayoutTxnCallback || hasPrivilagesTxnCallback ? (
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar("transactionCallback")}
                  >
                    <img
                      class="img-fluid img-thumbnail"
                      src={TxnCbIcon}
                      alt=""
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Callback
                    </h5>
                  </div>
                </div>
              ) : null}
              {hasPrivilagesSubmittedVendor || hasPrivilagesRegisterVendor ? (
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                  onClick={() => toggleRightBar("submittedVendor")}
                >
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <img
                      class="img-fluid img-thumbnail"
                      src={SubmittedVendorIcon}
                      alt=""
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Vendors
                    </h5>
                  </div>
                </div>
              ) : null}

              {AddWalletBalancePrivilages ? (
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar("addWalletBalance")}
                  >
                    <img
                      class="img-fluid img-thumbnail"
                      src={WalletBalanceIcon}
                      alt=""
                    />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Wallet Balance
                    </h5>
                  </div>
                </div>
              ) : null}

              <div
                className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                  onClick={() => toggleRightBar("ArchievedReport")}
                >
                  <img
                    class="img-fluid img-thumbnail"
                    src={ArchievedReportsIcon}
                    alt=""
                  />
                  <h5 className="mt-3 text-primary text-md text-sm">
                    Archived Reports
                  </h5>
                </div>
              </div>
              <>
                <div
                  className={`col-lg-3 col-md-3 col-4 mb-5 ${styles["tool-icon"]}`}
                >
                  <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    onClick={() => toggleRightBar("billingDetails")}
                  >
                    <img class="img-fluid img-thumbnail" src={Billing} alt="" />
                    <h5 className="mt-3 text-primary text-md text-sm">
                      Billing Details{" "}
                    </h5>
                    {loading && <small>Generating...</small>}
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

export default Tools;